// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PageAdminUsers .PageAdminUsers__mode {\n  border: 1px solid darkblue;\n  border-radius: 4px;\n  font-size: xx-small;\n  color: darkblue;\n  padding: 0 4px;\n  margin-left: 8px; }\n", ""]);
// Exports
module.exports = exports;
